import DOMPurify from 'isomorphic-dompurify';
import { marked } from 'marked';

marked.setOptions({
  gfm: true,
  breaks: true,
});

const ALLOWED_TAGS = [
  'p',
  'br',
  'strong',
  'em',
  'b',
  'i',
  'ul',
  'ol',
  'li',
  'h2',
  'h3',
  'h4',
  'code',
  'pre',
  'blockquote',
];

/** Parse assistant chat Markdown to sanitized HTML for v-html. */
export function renderChatMarkdown(source) {
  const raw = (source || '').trim();
  if (!raw) return '';
  const parsed = marked.parse(raw, { async: false });
  const html = typeof parsed === 'string' ? parsed : String(parsed);
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR: [],
  });
}
